"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toIconifyName = exports.DEFAULT_ICON = void 0;
var FA_SET_BY_PREFIX = {
    fas: "fa6-solid",
    far: "fa6-regular",
    fab: "fa6-brands",
    fal: "fa6-solid",
    fat: "fa6-solid",
    fad: "fa6-solid",
};
exports.DEFAULT_ICON = "solar:gallery-linear";
var toIconifyName = function (icon) {
    var _a, _b, _c;
    var name = (_a = icon === null || icon === void 0 ? void 0 : icon.name) === null || _a === void 0 ? void 0 : _a.trim();
    if (!name)
        return exports.DEFAULT_ICON;
    if (name.includes(":"))
        return name;
    var set = (_c = FA_SET_BY_PREFIX[(_b = icon === null || icon === void 0 ? void 0 : icon.prefix) !== null && _b !== void 0 ? _b : "fas"]) !== null && _c !== void 0 ? _c : "fa6-solid";
    return "".concat(set, ":").concat(name);
};
exports.toIconifyName = toIconifyName;
